export function getConfigurationObjectPaths(path) {
    const segments = path.split("/").filter((segment) => segment !== "");
    const paths = ["/"];
    let currentPath = "";
    segments.forEach((segment) => {
        currentPath += `/${segment}`;
        if (/[0-9]+$/.test(segment)) {
            paths.push(currentPath);
        }
    });
    return paths;
}
//# sourceMappingURL=getConfigurationObjectPaths.js.map